<template>
  <div class="w-full md:w-[500px] bg-white md:rounded-xl overflow-hidden flex flex-col h-full md:h-auto">
    <!-- Header -->
    <div class="flex justify-between items-center p-4 md:p-4 bg-[#2E6DD1] bg-opacity-10 border-b border-[#2E6DD1] border-opacity-20">
      <div class="flex gap-2 items-start">
        <img class="w-[30px] mt-1"
          loading="lazy" 
          alt="Logo BCompliance" 
          src="@/assets/img/common/logo.svg" 
        />
        <div class="flex flex-col">
          <div class="text-[#2E6DD1] font-[MuseoModerno] font-semibold text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-blue-500">BCompliance&amp;Law</div>
          <div class="text-[10px] font-bold opacity-80 leading-tight text-left text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-blue-500">Online</div>
        </div>
      </div>
      <button 
        @click="$emit('close')" 
        class="text-[#2E6DD1] hover:text-[#2E6DD1]/80 transition-colors"
        aria-label="Fechar chat"
      >✕</button>
    </div>

    <!-- Corpo do formulário -->
    <div class="flex-1 overflow-y-auto">
      <div class="p-4 md:p-8">
        <p class="text-[#2E6DD1] font-semibold mb-3 text-left text-xl md:text-base">
          Olá, vamos conversar pelo whatsapp?
        </p>
        <p class="text-gray-600 text-lg md:text-sm mb-8 text-left leading-relaxed">
          Para agilizar seu atendimento, preencha os campos abaixo e clique em
          iniciar conversa. 😀
        </p>

        <div class="space-y-5 md:space-y-4">
          <input 
            v-model="name" 
            placeholder="Nome*"
            class="w-full h-[56px] md:h-[52px] px-4 border-2 border-[#2E6DD1] border-opacity-20 rounded-lg focus:border-[#2E6DD1] focus:ring focus:ring-[#2E6DD1] focus:ring-opacity-50 outline-none transition-all text-lg md:text-base"
          />

          <input 
            v-model="email" 
            placeholder="E-mail"
            class="w-full h-[56px] md:h-[52px] px-4 border-2 border-[#2E6DD1] border-opacity-20 rounded-lg focus:border-[#2E6DD1] focus:ring focus:ring-[#2E6DD1] focus:ring-opacity-50 outline-none transition-all text-lg md:text-base"
          />

          <div class="flex gap-4">
            <CountriesPhoneCode 
              v-model="countryCode" 
              class="w-32 h-[56px] md:h-[52px] px-4 border-2 border-[#2E6DD1] border-opacity-20 rounded-lg focus:border-[#2E6DD1] focus:ring focus:ring-[#2E6DD1] focus:ring-opacity-50 outline-none transition-all text-lg md:text-base" 
            />
            <div class="flex-1">
              <input 
                @input="formatPhone" 
                v-model="phone" 
                maxlength="15" 
                type="tel" 
                placeholder="Telefone*" 
                name="tel"
                autocomplete="tel"
                required
                class="w-full h-[56px] md:h-[52px] px-4 border-2 border-[#2E6DD1] border-opacity-20 rounded-lg focus:border-[#2E6DD1] focus:ring focus:ring-[#2E6DD1] focus:ring-opacity-50 outline-none transition-all text-lg md:text-base"
              />
            </div>
          </div>

          <div class="text-sm md:text-xs text-gray-500 mt-2 text-left">
            * Campos obrigatórios
          </div>
        </div>
      </div>
    </div>

    <!-- Footer com botão -->
    <div class="p-4 bg-white border-t border-gray-100">
      <button 
        @click="sendMessage" 
        :disabled="isSending"
        class="w-full h-[56px] md:h-[52px] bg-white border-2 border-[#2E6DD1] text-[#2E6DD1] rounded-lg font-semibold hover:bg-[#2E6DD1] hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 text-lg md:text-base"
      >
        <template v-if="!isSending">
          <img 
            loading="lazy" 
            alt="Ícone do WhatsApp" 
            src="@/assets/img/home/help/whatsapp.svg"
            class="w-6 h-6"
          />
          <span>Iniciar conversa</span>
        </template>
        <svg v-else class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import CountriesPhoneCode from "@/components/CountriesPhoneCode.vue";
import { useWhatsAppChat } from "@/composables/useWhatsAppChat";

export default {
  name: 'WhatsAppForm',
  components: {
    CountriesPhoneCode,
  },
  emits: ['close'],
  setup() {
    const {
      name,
      phone,
      email,
      countryCode,
      isSending,
      formatPhone,
      sendMessage,
    } = useWhatsAppChat();

    return {
      name,
      phone,
      email,
      countryCode,
      isSending,
      formatPhone,
      sendMessage,
    };
  },
};
</script>